<template>
  <div>
    <div class="py-3"></div>
    <v-tabs v-model="activeTab" color="primary" grow>
      <v-tab>
        <v-icon left class="mr-2">mdi-format-list-bulleted</v-icon>
        광고 리스트
      </v-tab>
      <v-tab>
        <v-icon left class="mr-2">mdi-chart-pie</v-icon>
        광고 통계관리
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <Advertisement_List />
      </v-tab-item>
      <v-tab-item>
        <Advertisement_Statistics />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import Advertisement_List from './Advertisement_List.vue';
import Advertisement_Statistics from './Advertisement_Statistics.vue';

export default {
  name: 'Advertisement_House',
  components: {
    Advertisement_List,
    Advertisement_Statistics,
  },
  data: () => ({
    activeTab: 0,
  }),
};
</script>
